var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.authenticated)?_c('VictimListener'):_vm._e(),(_vm.authenticated)?_c('Navigation'):_vm._e(),_c('AppBar'),_c('Body'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }